module.exports = __webpack_public_path__ + "media/tu.5177e526.mp3";